import React, { useState, useCallback } from 'react'
import { Collapsible, Icon, TextStyle } from '@shopify/polaris'
import { ChevronDownMinor, ChevronUpMinor } from '@shopify/polaris-icons'
import './accordion-item.css'

const AccordionItem = (props) => {
  const [active, setActive] = useState(false);
  const handleToggle = useCallback(() => setActive((active) => !active), []);

  return (
    <div className="accordion-item">
      <button
        className='Polaris-Filters__FilterTrigger'
        onClick={handleToggle}
        aria-expanded={active}
        aria-controls="basic-collapsible"
      >
        <div className="Polaris-Filters__FilterTriggerLabelContainer">
          <h2 className="Polaris-Filters__FilterTriggerTitle">
            <TextStyle>
              {props.label || 'Toggle'}
            </TextStyle>
          </h2>
          <span>
            <Icon source={active ? ChevronUpMinor : ChevronDownMinor } color="inkLightest" />
          </span>
        </div>
      </button>
      <Collapsible
        open={active || props.forceActive}
        id="basic-collapsible"
        transition={{duration: '150ms', timingFunction: 'ease'}}
      >
        <div
          className="accordion-item__content"
          style={{
            padding: '1.6rem'
          }}
        >
          {props.children}
        </div>
      </Collapsible>
    </div>
  )
}

export default AccordionItem
